import React from "react";
import { Controller } from "react-hook-form";
import CustomDatePicker from "./CustomDatePicker";
import dayjs from "dayjs";

const DatePickerField = ({
  label,
  id,
  control,
  validationRules,
  errorMessage,
  maxDate = null,
  minDate = null,
  className = "form-control",
}) => {
  return (
    <div className="col-md-6 mb-3">
      <label
        htmlFor={id}
        className="form-label"
        style={{
          color: "#4CAF50",
          fontWeight: "bold",
          fontFamily: "'Poppins', sans-serif",
          fontSize: "14px",
        }}
      >
        {label}
      </label>
      <Controller
        name={id}
        control={control}
        rules={validationRules}
        render={({ field: { onChange, value } }) => (
          <CustomDatePicker
            label={label}
            value={value ? (dayjs.isDayjs(value) ? value : dayjs(value)) : null}
            onChange={(newValue) => {
              // Convert dayjs to string format for react-hook-form
              onChange(newValue ? dayjs(newValue).format("YYYY-MM-DD") : "");
            }}
            maxDate={maxDate}
            minDate={minDate}
            error={!!errorMessage}
            helperText={errorMessage}
            className={className}
          />
        )}
      />
      {errorMessage && (
        <div className="invalid-feedback" style={{ color: "#d9534f", display: "block" }}>
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default DatePickerField;

